import "./Services.module.css";
import SiteHeader from "@/reusable_sections/Header";
import OurServices from "./sections/OurServices";
import IndustriesServed from "./sections/IndustriesServed";
import WhyChooseGoldStar from "./sections/WhyChooseGoldStar";
import CustomerTestimonials from "./sections/CustomerTestimonials";
import ReadyToGetStarted from "./sections/ReadyToGetStarted";
import ContactUs from "./sections/ContactUs";
import SiteFooter from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <SiteHeader />
      <OurServices />
      <IndustriesServed />
      <WhyChooseGoldStar />
      <CustomerTestimonials />
      <ReadyToGetStarted />
      <ContactUs />
      <SiteFooter />
    </div>;
}